<div class="icon-container"><div class="icon"></div></div>
<span><ng-content></ng-content></span>
<button
  *ngIf="dismissable"
  type="button"
  (click)="onDismiss()">
  Dismiss
</button>
